$(document).ready(function(){
	$('.announcement-slider').slick({
		arrows:false,
		fade:true,
		autoplay:true,
		autoplaySpeed: 3000,
		speed:2000
	});
	$('.home-slider').slick({
		dots:true,
		arrows:false,
		autoplay: true,
		autoplaySpeed: 2000
	});
	$('.productSlider').slick({
    	dots:false,
		arrows:true
	});
	$('.lookbook-slider').slick({
		dots:false,
		arrows:true
	});
	$('.collection-item-row-mobile').slick({
		dots:false,
		arrows:true,
		slidesToShow:2
	});
	if($('.current-variant').length) {
		$id = $('.current-variant').val(),
		$index = $('.productSlider img[data-variant-id="' + $id + '"]').closest('.slick-slide').data('slick-index');
		$('.productSlider').slick('slickGoTo', $index);
	}

  if (window.matchMedia("(max-width: 749px)").matches) {
  var toTop = $('.site-header__cart, #add_to_cart_button');
  toTop.on('click', function() {
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    }, 0);
  });
  }
});


window.addEventListener("load",function(){

$(document).on('mouseover', '.thumbnails-wrapper li', function(){
	var $this = $(this).find('img');
	$this.trigger('click');
});

$(document).on('change', 'input[name="color"]', function(){
	var $this = $(this),
	$val = $this.val();
	$('.swatches .swatch-title span').text($val);
});

$(document).on('click', '.box-tabs li h3', function(){
	$(this).closest('li').toggleClass('show-content');
});

$(document).on('click', '.js-mobile-nav-toggle', function(){
	$('body').toggleClass('showlngswitcher');
	var $offset = $('.mobile-nav-wrapper').offset().top,
	$topVal = $('.mobile-nav-wrapper').outerHeight(),
	$top = $offset + $topVal;
	$('.lng-switcher').css({
		'top': $top
	})
});

$(document).on('click', '.boost-pfs-filter-top-sorting-wrapper', function(){
	$(this).closest('.filters-toolbar__item-child').find('.filters-toolbar__input-wrapper').toggle();
});

$(document).on('click', '.boost-pfs-filter-option-item .boost-pfs-filter-button', function(){
	if( $('.boost-pfs-filter-tree').is(':visible') ) {
		var $this = $(this),
		$text = $this.text(),
		$html = $this.html();
		setTimeout(function(){
			$this.closest('.boost-pfs-filter-option-content').find('.boost-pfs-filter-apply-button').trigger('click');
			if($('.boost-pfs-filter-options-wrapper li.selected').length > 0) {
				if( $('.clear-filters').length < 1) {
					$('.clear-filters').show();
				}
			} else {
				$('.clear-filters').hide();
			}
		}, 100);
	}
});

$(window).on('load', function(){
	if($('.boost-pfs-filter-options-wrapper li.selected').length > 0) {
		$('.clear-filters').show();
	} else {
		$('.clear-filters').hide();
	}
});

$(document).on('click', '.grid-toggle a', function(){
	var $this = $(this);
	if($this.hasClass('switch-single')) {
		$('.custom-grid').addClass('single-col');
	} else {
		$('.custom-grid').removeClass('single-col');
	}
	$('.grid-toggle a').removeClass('active-state');
	$this.addClass('active-state');
});

$(document).on('click', '.apply-filters', function(){
	location.reload();
});

$(document).on('click', '.close_filters', function(){
	$(this).closest('.filters-container').hide();
});

$(document).on('click', '.filter-toggle-mobile', function(){
	$('.filters-container').show();
});

$(document).on('click', '.popup-trigger', function(){
	$target = '#' + $(this).data('id');
	$($target).show().removeClass('hide');
  $(this).closest('#CustomerLoginForm').addClass('hide');
});

$(document).on('click', '.close-pop', function(){
	$target = $(this).closest('.popup-container');
	$($target).hide();
});

$(document).on('click', '.accordion-trigger', function(){
	var $this = $(this),
	$target = $this.closest('.accordion-item').find('.accordion-content');
	if($this.hasClass('accordion-open')) {
		$this.removeClass('accordion-open');
		$target.slideUp();
	} else {
		$this.addClass('accordion-open');
		$target.slideDown();
	}
});

$(document).on('click', '.faq-grid-container .section-header h1 a', function(){
	$('.accordion-trigger').addClass('accordion-open');
	$('.accordion-content').slideDown();
});

$(document).on('click', '.ui-tabs-anchor', function(){
	var $this = $(this),
	$parent = $this.closest('li'),
	$target = $this.attr('href');
	$('.ui-tabs-panel').hide();
	$($target).show();
	$('.ui-tabs-active').removeClass('ui-state-active').removeClass('ui-tabs-active');
	$parent.addClass('ui-state-active').addClass('ui-tabs-active');
	return false;
});

$(document).on('click', 'a[data-popup]', function(){
	var $this = $(this),
	$target = '.' + $this.data('popup');
	$($target).show();
	return false;
});

$(document).on('click', '.close-popup', function(){
	$(this).closest('.popup-main').hide();
	return false;
});

$(document).on('mouseover', '.swatch-item', function(){
	var $this = $(this);
	if($this.closest('.product-card').length) {
		$parent = $this.closest('.product-card');
	} else {
		$parent = $this.closest('.boost-pfs-filter-product-item-inner')
	}
	var $src = $parent.find('.product-image-holder img:last-of-type').attr('src'),
	$variantImage = $this.data('image');
	if($parent.attr('data-src') == undefined) {
		$parent.attr('data-src', $src);
	}
	$parent.find('.product-image-holder img:last-of-type').attr('src', $variantImage);
});

$(document).on('mouseleave', '.custom-grid .grid__item', function(){
	var $this = $(this);
	if($this.find('.product-card').length) {
		$parent = $this.find('.product-card');
	} else {
		$parent = $this.find('.boost-pfs-filter-product-item-inner')
	}
	var $src = $parent.attr('data-src');
	$this.find('.product-image-holder img:last-of-type').attr('src', $src);
});

document.addEventListener("DOMContentLoaded", function() {
	if($('#Huratips-Loop').length) {
		var endlessScroll = new Ajaxinate({
			container: '#Huratips-Loop',
			pagination: '#Huratips-Pagination'
		});
	}
});

$.urlParam = function(name){
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results==null) {
		return null;
	}
	return decodeURI(results[1]) || 0;
}

});


// shipping page popup 

document.addEventListener('click', (e) => {
  const link = e.target.closest('.shipping-map-link');
  if (!link) return;

  e.preventDefault();

  const modal = document.createElement('div');
  modal.className = 'shipping-map-modal';

  modal.innerHTML = `
    <div class="shipping-map-modal__box">
      <button class="shipping-map-modal__close" type="button" aria-label="Close">
        &times;
      </button>
      <img class="shipping-map-modal__image"
           src="${link.href}"
           alt="UPS Ground Transit Times Map">
    </div>
  `;

  document.body.append(modal);
  modal.classList.add('is-open');
  document.body.classList.add('shipping-map-modal-open');

  const close = () => {
    modal.remove();
    document.body.classList.remove('shipping-map-modal-open');
  };

  modal.querySelector('.shipping-map-modal__close').onclick = close;

  modal.onclick = (e) => {
    if (e.target === modal) close();
  };

  const escape = (e) => {
    if (e.key === 'Escape') {
      close();
      document.removeEventListener('keydown', escape);
    }
  };

  document.addEventListener('keydown', escape);
});
/* End Shipping map lightbox */